import {Big} from 'big.js';
import {isBlank} from "./string-utils";
import {EnumDisplayMode} from "../domain/in/quote/enum-display-mode";

const WEEKS_PER_MONTH = new Big("4.348");

export function bigToString(bigNumber: Big, fractionDigits: number = 40): string {
    if (bigNumber == null) {
        return new Big("0").toFixed(fractionDigits);
    }
    return bigNumber.toFixed(fractionDigits, Big.roundHalfUp);
}

export function parseBig(str: string): Big {
    if (isBlank(str)) {
        return new Big("0");
    }
    return new Big(str);
}

export function getWeeklyAndMonthlyAmount(totalAppliedPrice: string, displayMode: EnumDisplayMode): { weekly: string, monthly: string } {
    const total = parseBig(totalAppliedPrice);
    if (displayMode === EnumDisplayMode.WEEKLY) {
        return {weekly: bigToString(total), monthly: bigToString(total.mul(WEEKS_PER_MONTH))};
    }
    if (displayMode === EnumDisplayMode.MONTHLY) {
        return {weekly: bigToString(total.div(WEEKS_PER_MONTH)), monthly: bigToString(total)};
    }
    return {weekly: bigToString(total), monthly: bigToString(total)};
}

export function generateUniqueId(): string {
    return Math.random().toString(36).substr(2, 9);
}

export function removeDecimalPointFromInput(event: any): boolean {
    return event.charCode >= 48 && event.charCode <= 57;
}

export function removeNegativeValueFromInput(event: any): boolean {
    return event.charCode !== 45;
}

export class MathUtils {

    static toString(bigNumber: Big): string {
        const fractionDigits = 3
        if (bigNumber == null) {
            return new Big("0").toFixed(fractionDigits);
        }
        return bigNumber.toFixed(fractionDigits);
    }

    static round(bigNumber: Big, decimal: number): number {
        if (bigNumber == null) {
            return 0;
        }
        return Number(bigNumber.toFixed(decimal));
    }

    static bigIsNullOrZero(big: Big): boolean {
        return big == null || parseFloat(big.toFixed(3)) === 0;
    }

    static bigIsBelowZero(big: Big): boolean {
        return big != null && parseFloat(big.toFixed(3)) < 0;
    }

    static bigIsInteger(big: Big): boolean {
        return big != null && parseFloat(big.toString()) === parseInt(big.toString(), 10);
    }

    static maxArrayBig(bigs: Big[]) {
        let max = bigs[0];
        for (let i = 1; i < bigs.length; i++) {
            if (bigs[i].gt(max)) {
                max = bigs[i];
            }
        }
        return max;
    }

    static maxBig(big1: Big, big2: Big): Big {
        let max = new Big(big2);
        if (big1.gt(big2)) {
            max = big1;
        }
        return max;
    }
}
